"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBasePath = exports.getAppName = exports.AppViews = void 0;
let AppViews = exports.AppViews = /*#__PURE__*/function (AppViews) {
  AppViews["BasePath"] = "";
  AppViews["Issues"] = "issues";
  AppViews["Types"] = "types";
  AppViews["CustomFields"] = "custom-fields";
  AppViews["Permissions"] = "permissions";
  AppViews["RootCauses"] = "root-causes";
  AppViews["Templates"] = "templates";
  AppViews["Statuses"] = "statuses";
  AppViews["DeletedIssues"] = "deleted-issues";
  return AppViews;
}({});
const getAppName = () => {
  const match = window.location.pathname.match(/\/(.*)\/issues?\/projects/);
  return match && ["build", "docs"].includes(match[1]) ? match[1] : "docs";
};
exports.getAppName = getAppName;
const getBasePath = projectId => {
  // @TODO: we should not allow a base path that doesn't have a project ID,
  // but that will take a bit of refactoring elsewhere
  if (!projectId) {
    return "";
  }
  return "/".concat(getAppName(), "/issues/projects/").concat(projectId);
};
exports.getBasePath = getBasePath;
//# sourceMappingURL=viewPaths.js.map